/* eslint-disable no-unused-vars */
import {
  call, put, select, delay,
} from 'redux-saga/effects';
import { getLocale, getToken } from './redux';
import { CONNECTION_ERROR } from '../configs/serverStatusCodes';
import { rejectActionPromise } from './rejectActionPromise';
import { authorizedLogout, refreshKeyCloak } from '../modules/Authorized/actions';
import { intlShape } from '../components/base/IntlProviderWrapper';

function* doRequest(url, method, token, pool, locale, headers, noStringify) {
  const {
    formatMessage,
  } = intlShape;
  const data = {
    method,
    cache: 'no-cache',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': locale,
      Authorization: `Bearer ${token}`,
    },
  };
  data.headers = { ...data.headers, ...headers };
  const urlWithQuery = new URL(url);
  if (pool) {
    if (method !== 'GET') {
      if (noStringify) {
        data.body = pool;
        delete data.headers['Content-Type'];
      } else {
        data.body = JSON.stringify(pool);
      }
    } else {
      Object.keys(pool).forEach(key => {
        if (key === 'filter' || key === 'sort') {
          pool[key].forEach(item => urlWithQuery.searchParams.append(key, item));
        } else if (Array.isArray(pool[key])) {
          pool[key].forEach(item => urlWithQuery.searchParams.append(`${key}[]`, item));
        } else {
          urlWithQuery.searchParams.append(key, pool[key]);
        }
      });
    }
  }
  let fetchData = null;
  try {
    fetchData = yield fetch(urlWithQuery, data);
  } catch (e) {
    fetchData = { status: CONNECTION_ERROR, message: formatMessage({ id: 'error.connection' }) };
  }
  return fetchData;
}

export default function* makeRequest(url, pool = {}, action, method = 'POST', removeToken = false, headers = {}, noStringify = false) {
  const {
    formatMessage,
  } = intlShape;
  const token = yield select(getToken);
  const locale = yield select(getLocale);
  try {
    let userDataResponse = null;
    userDataResponse = yield doRequest(url, method, token, pool, locale, headers, noStringify);
    // if (userDataResponse.status === 401 && !url.includes('/auth/login')) {
    //   delay(200);
    //   userDataResponse = yield doRequest(url, method, token, pool, locale, headers, noStringify);
    // }
    if (userDataResponse.status === 401 && !url.includes('/auth/login') && !url.includes('/logout')) {
      const response = yield put(authorizedLogout());
      yield response;
      setTimeout(() => { window.location.href = '/'; }, 100);
    }
    return userDataResponse;
  } catch (e) {
    const userDataResponse = { status: CONNECTION_ERROR, message: formatMessage({ id: 'error.connection' }) };
    yield call(rejectActionPromise(action, userDataResponse));
    return userDataResponse;
  }
}

export function* getBodyJson(res, defaultValue = null) {
  let data;
  try {
    data = yield res.json();
  } catch (e) {
    data = defaultValue;
  }
  return data;
}
